import getHelper from '../../../services/getHelper';

export default getHelper('/support-expert-assignment/:id');
